import React, {useState} from 'react';
import TableColumnConfig from "./TableColumnConfig";
import TableConfigConfirmDeleteModal from "./TableConfigConfirmDeleteModal";
import TableConfigAddRow from "./TableConfigAddRow";
import {useDispatch, useSelector} from "react-redux";
import {getDynamicTableById, installationSelectData} from "../../redux-store/selectors";
import {
    editDynamicTable,
    getDynamicTableList,
    setShowAddColumnModal,
    setShowAddRowModal,
    setShowDeleteModal,
    setTableColumns
} from "../../redux-store/dynamicTable";
import TableConfigAddColumnModal from "./TableConfigAddColumnModal";


function TableConfigItem({children, id}) {

    const {selected} = useSelector(installationSelectData)
    const table = useSelector(getDynamicTableById(id))

    const dispatch = useDispatch()

    const [dragOver, setDragOver] = useState("");

    const handleDragStart = e => {
        const {id} = e.target;
        const idx = table.columns.findIndex(obj => obj.id === parseInt(id));
        e.dataTransfer.setData("colIdx", idx);
    };

    const handleDragOver = e => e.preventDefault();
    const handleDragEnter = e => {
        const {id} = e.target;
        setDragOver(id);
    };

    const handleOnDrop = e => {
        const {id} = e.target;
        if (id) {
            const droppedColIdx = table.columns.findIndex(obj => obj.id === parseInt(id));
            const draggedColIdx = e.dataTransfer.getData("colIdx");
            const tempCols = [...table.columns];


            tempCols[draggedColIdx] = table.columns[droppedColIdx];
            tempCols[droppedColIdx] = table.columns[draggedColIdx];

            dispatch(setTableColumns({id: table.id, tempCols}))

        }
        setDragOver("");
    };

    const handleEdit = async () => {
        dispatch(editDynamicTable({tableId: id, installationId: selected.value}))
        dispatch(getDynamicTableList(selected.value))
    }

    return (<>
        <div className={"container-fluid"}>
            <div className={"row pb-2 pt-3"}>
                <div className={"col-12 col-md-12 col-lg-4 col-xl-4"}>
                    <h4>Editor tabele</h4>
                </div>
                <div className={"col-12 col-md-12 col-lg-8 col-xl-8 text-right"}>
                    <button
                        onClick={handleEdit}
                        className={"btn btn-modal-confirm"}>{"Sačuvaj izmjene"}</button>
                    <button
                        onClick={() => {
                            dispatch(setShowAddRowModal({show: true, id}))
                        }}
                        className={"btn btn-modal-confirm"}>{"Dodaj lokaciju"}</button>
                    <button
                        onClick={() => {
                            dispatch(setShowAddColumnModal({show: true, id}))
                        }}
                        className={"btn btn-modal-confirm"}>{"Dodaj kolonu"}</button>
                    <button
                        onClick={() => {
                            dispatch(setShowDeleteModal({show: true, id}))
                        }}
                        className={"btn btn-modal-confirm-delete"}
                    >{"Obriši tabelu"}</button>
                </div>
            </div>
            <hr/>
            <div className={"row pb-2"}>
                <div className={"col-12"}>
                    <h4>Lokacije</h4>
                </div>
            </div>
            <div className={"row pb-2"} style={{paddingLeft: "200px", flexWrap: "nowrap"}}>
                {table.columns.map(col => <TableColumnConfig className="col-1" id={col.id}
                                                             key={col.id}
                                                             col={col}
                                                             tableid={id}
                                                             draggable
                                                             onDragStart={handleDragStart}
                                                             onDragOver={handleDragOver}
                                                             onDrop={handleOnDrop}
                                                             onDragEnter={handleDragEnter}
                                                             dragover={col.id === dragOver ? true : undefined}
                />)}
            </div>
            <div className="row">
                <div className={"col-12"}>
                    {children}
                </div>
            </div>
        </div>
        <TableConfigAddColumnModal id={id}/>
        <TableConfigConfirmDeleteModal id={id}/>
        <TableConfigAddRow id={id}/>
    </>);
}

export default TableConfigItem;